import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import api from '../../services/api';

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data } = await api.get('/products');
        setProducts(data.data || []);
      } catch (error) {
        console.error('Error fetching products:', error);
        // Datos de ejemplo si falla la API
        setProducts([
          { id: 1, name: 'Pizza Margherita', description: 'Masa artesanal, tomate y mozzarella', price_usd: 12.00, icon: '🍕', badge: '🔥 Popular' },
          { id: 2, name: 'Brownie Supreme', description: 'Chocolate belga 70% con nueces', price_usd: 5.00, icon: '🍫', badge: '⭐ Más vendido' },
          { id: 3, name: 'Galleta Crisp', description: 'Chispas de chocolate y sal marina', price_usd: 4.00, icon: '🍪', badge: '🥇 Clásica' }
        ]);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  return (
    <section id="productos" className="py-12 md:py-16 lg:py-20 px-4 md:px-8 max-w-[1300px] mx-auto bg-background">
      <div className="flex flex-wrap justify-between items-end gap-4 mb-8 md:mb-12">
        <div className="max-w-[600px]">
          <div className="text-gold text-xs font-semibold uppercase tracking-wider mb-2">🍪 Nuestra Selección</div>
          <h2 className="font-serif text-3xl md:text-4xl text-primary">Productos <span className="text-gold">horneados</span></h2>
          <p className="text-text-secondary font-light text-base mt-1">Cada uno con su historia, su textura y su sabor único</p>
        </div>
        <a href="#inicio" className="text-gold font-medium text-sm hover:gap-2 transition flex items-center gap-1 min-h-[44px] px-2">← Volver al horno</a>
      </div>

      {loading ? (
        <div className="text-center py-12">Cargando productos...</div>
      ) : products.length === 0 ? (
        <div className="text-center py-12 text-text-secondary">No hay productos disponibles</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {products.map((product) => <ProductCard key={product.id} product={product} />)}
        </div>
      )}
    </section>
  );
};

export default ProductGrid;
